import axios from 'axios';

const { VUE_APP_BASE_URL } = process.env;
const namespace = 'api/ocean';
const version = 'v1';

const instance = axios.create({ baseURL: `${VUE_APP_BASE_URL}/${namespace}/${version}` });

export const resetPassword = data => instance.post('/reset-password', data);

export default {
  resetPassword
};
